import type { Maybe } from '@custom/dx3';
import { HalfCircleProgress } from '@custom/dx3';
import classnames from 'classnames';
import { COPY as ALL_COPY } from '../../assets/copy/copy';
import styles from './LevelDisplayStyles.module.scss';

type LevelDisplayProps = {
  currentLevel?: Maybe<string>;
  currentPoints?: Maybe<number>;
  nextLevel?: Maybe<string>;
  nextLevelPoints?: Maybe<number>;
  progressPercentage?: Maybe<number>;
} & JSX.IntrinsicElements['div'];

const COPY = ALL_COPY.LEVEL_COMPONENT;

export function LevelDisplay({
  className,
  currentLevel,
  currentPoints,
  nextLevel,
  nextLevelPoints,
  progressPercentage,
  ...rest
}: LevelDisplayProps): JSX.Element {
  return (
    <div
      className={classnames(styles['level-display-container'], className)}
      {...rest}
    >
      <div className={styles['title-container']}>
        <p>{COPY.TITLE}</p>
      </div>
      <div className={styles['level-container']}>
        <p className={styles['level-display']}>{currentLevel}</p>
        {nextLevel ? (
          <p className={styles['next-display']}>
            {COPY.NEXT_LEVEL} {nextLevel}
          </p>
        ) : (
          <p className={styles['next-display']}>{COPY.TOP_LEVEL}</p>
        )}
      </div>
      <div className={styles['level-bar-container']}>
        <HalfCircleProgress
          value={progressPercentage ?? 0}
          max={100}
          min={0}
          color={'var(--color-half-circle-progress)'}
        />
        {nextLevelPoints && (
          <div className={styles['level-credit-info']}>
            <p className={styles['progress']}>{`${
              currentPoints ?? 0
            }/${nextLevelPoints}`}</p>
            <p className={styles['text']}>{COPY.LEVEL_CREDITS}</p>
          </div>
        )}
      </div>
    </div>
  );
}
